(function() {
    const isScriptLoaded = (scriptId) => {
        return document.querySelector(`script[src*="${scriptId}"]`) !== null;
    };

    document.addEventListener('DOMContentLoaded', function() {
        let scriptsLoaded = false;
        let interactionTimeout = null;
        const scriptUrls = [
            "//theturmeric.co/cdn/shopifycloud/shopify/assets/themes_support/shopify_common-33bb9d312118840468a53f36b59c62c1e8f2b7d1a0a77250db9e300441827470.js",
            "//theturmeric.co/cdn/shopifycloud/shopify/assets/themes_support/option_selection-6f7ad633c5e28837fa6ad78e9835b04d09b5c5c072403701d8bffc9180e7fec7.js",
            'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=JVZ643',
            
            
            "//theturmeric.co/cdn/shop/t/549/assets/yotpo-reviews-widget.js?v=10736091111908408951775060202",
            !isScriptLoaded('n91c4cd') && '//cdn.omniconvert.com/js/n91c4cd.js',
            "//theturmeric.co/cdn/shop/t/549/assets/back-flush-cache.js?v=76331650438624505101775059253",
            'https://cdn-widgetsrepository.yotpo.com/v1/loader/5jTwhtSmMrw3RGPb4AK1f23q1Kxbx6vEhG2OoJBX',
            'https://app.addsauce.com/widgets/tv/shopify--the-turmeric-co/sauce_general.js',
            /*   'https://cdn-swell-assets.yotpo.com/app.v1.0.368.js'*/
        ];
        const styleUrls = [];

        function loadDeferredAssets() {
            if (scriptsLoaded) return;
            let log = false;

            scriptUrls.forEach(urlItem => {
                if (urlItem) {
                    let script = document.createElement('script');
                    script.src = urlItem;
                    document.head.appendChild(script);
                    log = true;
                }
            });

            styleUrls.forEach(url => {
                if (url) {
                    let style = document.createElement('link');
                    style.rel = 'stylesheet';
                    style.href = url;
                    document.head.appendChild(style);
                    log = true;
                }
            });

            console.log('Shopioso deferred assets loaded');

            scriptsLoaded = true;
            clearTimeout(interactionTimeout);
        }

        document.addEventListener('click', loadDeferredAssets, { once: true });
        document.addEventListener('scroll', loadDeferredAssets, { once: true });
        document.addEventListener('touchstart', loadDeferredAssets, { once: true });
        document.addEventListener('mousemove', loadDeferredAssets, { once: true });
        document.addEventListener('keydown', loadDeferredAssets, { once: true });

        interactionTimeout = setTimeout(() => {
            if (scriptsLoaded) return;
            loadDeferredAssets();
        }, 5000);
    });
})();
